import { Component } from '@angular/core';
import { CtParametersAddEditComponent } from './ct-parameters-add-edit/ct-parameters-add-edit.component';
import { Subject, takeUntil } from 'rxjs';
import { ICtParametersDetailed } from 'src/app/interfaces/CtParameters/ICtParametersDetailed';
import { CtParametersService } from 'src/app/services/ctparameters.service';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { COLORS } from 'src/styles/colors';
import { SwalToastService } from 'src/app/services/swal.service';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-ct-parameters',
    templateUrl: './ct-parameters.component.html',
    styleUrls: ['./ct-parameters.component.css'],
    standalone: false
})
export class CtParametersComponent {
  public addComp = CtParametersAddEditComponent;

  private destroy$ = new Subject<void>();

  ctParameters?: ICtParametersDetailed[];
  isLoading: boolean = false;

  constructor(
    private readonly ctParametersService: CtParametersService,
    private readonly translate: TranslateService,
    private readonly swalToastService: SwalToastService,
    private readonly permissionService: PermissionService
  ) {}

  hasPermission(permission: string[]): boolean {
    return this.permissionService.can(permission);
  }

  openModalFun(item?: ICtParametersDetailed) {
    this.ctParametersService.ctParametersModalSub.next(true);
    this.ctParametersService.ctParametersEditSub.next(item);
  }

  deleteFun(id: number) {
    Swal.fire({
      text: `${this.translate.instant(
        'deletePlaceholder2'
      )} ${this.translate.instant('3D-CT Parameter')}?`,
      showDenyButton: false,
      showCancelButton: true,
      cancelButtonText: `${this.translate.instant('Cancel')}`,
      confirmButtonText: `${this.translate.instant('Ok')}`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.ctParametersService.deleteCtParameters(id.toString()).subscribe({
          next: (d) => {
            this.swalToastService.toastSuccess(
              '3D-CT Parameter record deleted successfully'
            );
            this.ctParametersService.deleteCtParametersFromTable(id.toString());
          },
          error: (err) => {
            this.swalToastService.toastError(
              'Unable to delete 3D-CT Parameter record'
            );
          },
        });
      } else if (result.isDenied) {
        Swal.fire(
          `${this.translate.instant('3D-CT Parameters record is not deleted')}`,
          '',
          'info'
        );
      }
    });
  }
  ngOnInit() {
    this.ctParametersService.ctParametersLoadingSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: boolean) => {
        this.isLoading = data;
      });

    this.ctParametersService.ctParametersDataSub
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: ICtParametersDetailed[]) => {
        this.ctParameters = data;
      });

    this.ctParametersService.getData();
  }
}
